module.exports = __webpack_public_path__ + "static/media/banner-photo768@3x.80567977.jpg";